import { render, staticRenderFns } from "./PositionsTab.vue?vue&type=template&id=8318b3fe"
import script from "./PositionsTab.vue?vue&type=script&lang=js"
export * from "./PositionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports